import { observer } from 'mobx-react-lite'

import User from 'singletons/User'
import RxChangeCard from 'components/Dashboard/cards/RxChange'
import SectionList from '../common/SectionList'
import SectionRow from '../common/SectionRow'
import DateBlock from '../Visit/TabPanel/tabs/Visits/common/DateBlock'

import { Navigate } from 'react-router-dom'
import { DASHBOARD } from 'constants/routing'

const RxChangeRequest = () => {
  const { provider, isHidePrescriptionsFeatureFlagEnabled } = User

  if (!provider) {
    return null
  }

  if (isHidePrescriptionsFeatureFlagEnabled) {
    return <Navigate to={DASHBOARD} replace />
  }

  return (
    <div className="py-10 px-4 bg-white">
      <SectionList>
        {provider.rxChangesList.list.map((rxChange) => (
          <SectionRow
            leftContent={rxChange.requestedDate && <DateBlock date={rxChange.requestedDate} />}
            rightContent={<RxChangeCard rxChange={rxChange} />}
            key={rxChange.rxChangeRequestId}
          />
        ))}
      </SectionList>
    </div>
  )
}

export default observer(RxChangeRequest)
